import AbstractStore from '../../base/abstract.store'

const countriesStore = new AbstractStore({key:'countryList',lifeTime:'2D'})
const dictDataStore = new AbstractStore({key:'dictionaryData',lifeTime:'1D'})

export {
    countriesStore,
    dictDataStore
}